import { useTranslation } from "react-i18next";
import PageWrapper from 'components/page/PageWrapper';
import SlideUp from "components/animation/SlideUp";

import bg from 'assets/images/banner/banner01.jpg';
import img1 from 'assets/images/corporation/aboutus_01.jpg';
import img2 from 'assets/images/corporation/aboutus_02.jpg';
import bgService from 'assets/images/corporation/bg_service.jpg'

export default function Overview(){
  const {t} = useTranslation();
  const menuName= t('menu.sub-corporation');
  const path=[{url:'/corporation', name:t('menu.main-about')}, {url:'/corporation', name:menuName}];
  const title = t('corporation.banner.title')
  const comment = t('corporation.banner.comment')

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex flex-row justify-center">
        <div className={`z-10 flex flex-col px-mobile lg:min-w-[1200px] lg:max-w-[1200px]`}>
          <div className={`flex flex-col lg:flex-row-reverse items-start mb-8`}>
            <SlideUp>
            <div className="flex flex-col items-start justify-start w-full mb-4 lg:ml-20">
              <p className="mb-4 text-lg lg:text-3xl text-dark-navy">{t('corporation.body.title-1')}</p>
              <p className="text-xs text-gray-500 lg:text-base" dangerouslySetInnerHTML={{__html:t('corporation.body.comment-1')}}></p>
            </div>
            </SlideUp>
            <SlideUp>
            <img src={img1} alt="corporation" className="w-[567px]"/>
            </SlideUp>
          </div>
          <div className={`flex flex-col lg:flex-row lg:-mt-36 lg:items-center`}>
            <SlideUp>
            <div className="flex flex-col justify-center w-full mb-4 lg:ml-20 lg:mr-20">
              <p className="mb-4 text-lg lg:text-3xl text-dark-navy">{t('corporation.body.title-2')}</p>
              <p className="text-xs text-gray-500 lg:text-base " dangerouslySetInnerHTML={{__html:t('corporation.body.comment-2')}}></p>
            </div>
            </SlideUp>
            <SlideUp>
            <img src={img2} alt='corporation2' className="w-[553px]"/>
            </SlideUp>
          </div>
        </div>
      </div>
      <div className={`h-[229px] lg:h-[695px] pr-2` +
        ` bg-cover lg:-mt-20 flex flex-col justify-center lg:items-center items-end m-mobile lg:m-0`}
        style={{backgroundImage:`url(${bg})`}}>
        <SlideUp>
        <p className="mb-6 text-2xl text-white lg:mb-10 lg:text-3xl">{t('corporation.body.title-3')}</p>
        </SlideUp>
        <SlideUp delay={400}>
        <p className="text-xs text-white text-end lg:text-center lg:text-lg" dangerouslySetInnerHTML={{__html:t('corporation.body.comment-3')}}></p>
        </SlideUp>
      </div>
      <div className={`lg:m-[155px] h-[228px] bg-cover`+
        ` lg:h-[618px] flex flex-col justify-center items-center m-mobile`}
        style={{backgroundImage:`url(${bgService})`}}>
        <SlideUp>
        <p className="mb-6 text-2xl text-center lg:mb-10 lg:text-3xl">{t('corporation.body.title-4')}</p>
        </SlideUp>
        <SlideUp delay={400}>
        <p className="text-xs text-center lg:text-lg" dangerouslySetInnerHTML={{__html:t('corporation.body.comment-4')}}></p>
        </SlideUp>
      </div>
    </PageWrapper>
  );
}